import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-financials',
    templateUrl: './financials.component.html',
    styleUrls: ['./financials.component.scss']
})
export class FinancialsComponent implements OnInit, OnDestroy {
    src: string;
    documents = [
        { title: 'AF 2024-25 Balance Sheet', path: '/assets/pdf/about/financials/AF 2024-25 Balance Sheet.pdf' },
        { title: 'SF 2024-25 Balance Sheet', path: '/assets/pdf/about/financials/SF 2024-25 Balance Sheet.pdf' },
        { title: 'AF 2023-24 Balance Sheet', path: '/assets/pdf/about/financials/AF - 2023-24 Balance Sheet.pdf' },
        { title: 'SF 2023-24 Balance Sheet', path: '/assets/pdf/about/financials/SF - 2023-24 Balance Sheet.pdf' },
        { title: 'AF & SF 2022-23 Balance Sheet', path: '/assets/pdf/about/financials/AF & SF (2022-23) Balance Sheet.pdf' },
        { title: 'AF 2021-22 Balance Sheet', path: '/assets/pdf/about/financials/AF (2021-22) Balance Sheet.pdf' },
        { title: 'SF 2021-22 Balance Sheet', path: '/assets/pdf/about/financials/SF (2021-22 )Balance Sheet.pdf' },
        { title: 'AF & SF 2020-21 Balance Sheet', path: '/assets/pdf/about/financials/AF & SF (2020-21)Balance Sheet .pdf' }
    ];

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
        this.src = this.documents[0].path;
    }

    changeDoc(path: string) {
        this.src = path;
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
